import LegalPage from './LegalPage.js';

export default function TermsOfServicePage() {
  return (
    <LegalPage title="Terms of service">
      <p>
        These terms cover use of DriftCal at driftcal.net, operated by ADV Solutions
        (Australia). By using the site you agree to them.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">The service</h2>
      <p>
        DriftCal lists drift events and related promoter and partner information. Event
        details are supplied by organisers and may change. We do not sell tickets or
        run the events ourselves.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Accounts</h2>
      <p>
        You must provide accurate details if you create an account. Keep your password
        or connected Google/Facebook login under your control. You are responsible for
        activity on your account. We may suspend accounts that abuse the service or
        other users.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Content you submit</h2>
      <p>
        Promoters and partners are responsible for the accuracy of events, images, and
        business details they publish. You must have the right to use any images or
        logos you upload. We may remove content that is misleading, unlawful, or
        harmful.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Acceptable use</h2>
      <p>
        Do not attempt to break the site, scrape in a way that harms the service, or
        use DriftCal to spam or harass. Public API use must follow the published API
        terms and rate limits.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Disclaimer</h2>
      <p>
        The calendar is provided as-is. We do not warrant that listings are complete
        or that the site will always be available. To the extent allowed by Australian
        law we are not liable for losses from relying on event information or from
        downtime.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Changes</h2>
      <p>
        We may update these terms. Continued use after a change means you accept the
        new terms. The date at the top of this page is the latest update.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Contact</h2>
      <p>
        <a className="text-white underline" href="mailto:contact@shopadv.net">
          contact@shopadv.net
        </a>
        . Privacy details are in our{' '}
        <a className="text-white underline" href="/privacy">
          privacy policy
        </a>
        .
      </p>
    </LegalPage>
  );
}
